/* eslint no-mixed-operators:0 */
import { useState, useContext, useEffect } from 'react';
import {
  Button,
  Box,
  ButtonGroup,
  InputLabel,
} from '@mui/material';

import { AuthContext } from 'components';

export const availableCategoryGroups = ['MEN', 'WOMEN', 'BOYS', 'GIRLS', 'HOME'];

export const Departments = (props) => {
  const { onChange, department, preselectDepartment = true } = props;
  const [ enabledDepartments, setEnabledDepartments ] = useState(['MEN', 'WOMEN', 'BOYS', 'GIRLS', 'HOME']);
  const [ selectedDepartment, setSelectedDepartment ] = useState(department || null);
  const { account, selectedStore } = useContext(AuthContext);

  useEffect(() => {
    if (account.acctStores[selectedStore] && account.acctStores[selectedStore].departments) {
      setEnabledDepartments(account.acctStores[selectedStore].departments.map((i) => availableCategoryGroups[i]))
    }
  }, [account, selectedStore])

  useEffect(() => {
    if (preselectDepartment && enabledDepartments.indexOf(selectedDepartment) === -1) {
      setSelectedDepartment(enabledDepartments[0])
    }
    if (enabledDepartments.length === 1) {
      setSelectedDepartment(enabledDepartments[0])
    }
  }, [enabledDepartments])

  useEffect(() => {
    if (onChange) {
      onChange(selectedDepartment);
    }
  }, [selectedDepartment]);
  
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
      }}
    >
      <InputLabel shrink variant="standard">Departments</InputLabel>
      <ButtonGroup color="secondary" variant="outlined" aria-label="Departments">
        {enabledDepartments.map((g) => 
          <Button
            key={g}
            size="small"
            onClick={() => { setSelectedDepartment(g) }} variant={ g===selectedDepartment ? 'contained' : 'outlined' }
          >
            {g}
          </Button>)
        }
      </ButtonGroup>
    </Box>
  );
}